<div class="flex items-center justify-between rounded-2xl bg-neutral-100 px-4 py-1">
  <div class="flex items-center gap-2">
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="flex items-center gap-2">
    <ng-content select="[actions]"></ng-content>
    <button
      class="flex items-center justify-center text-neutral-400 hover:text-neutral-500"
      mat-dialog-close
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
